export const mountableSteps = {
	stepLabel: "Step",
	addStep: "Add new step",
	removeStep: "Delete step",
	reorderStep: "Reorder step",
	itemStatus: {
		active: "Active item",
		inactive: "Inactive item",
		modal: {
			title: {
				activate: "Activate mountable item",
				deactivate: "Deactivate mountable item",
			},
			message: {
				activate:
					"If this item is also part of other mountable products, do you want to activate it in all of them?",
				deactivate:
					"If this item is also part of other mountable products, do you want to deactivate it in all of them?",
			},
		},
	},
	emptyState: {
		title: "Start by adding a new step",
		description: "Steps let your customer choose meat doneness, sides, extras, and more.",
	},
	cardHeader: {
		titlePlaceholder: "Step name",
	},
	fields: {
		title: {
			label: "Title",
			placeholder: "Enter the step title",
		},
		pricing: {
			label: "Pricing",
			placeholder: "Choose the pricing model for this step",
			options: {
				sum: {
					label: "Additional",
					tooltip: "Every item added will be incremented in the product value",
				},
				average: {
					label: "Average",
					tooltip: "The average of selected items will be incremented",
				},
				higher: {
					label: "Highest value",
					tooltip: "The highest value among items will be added to the product value",
				},
			},
		},
		min: {
			label: "Min selectable qty for the step",
			tooltip: "Minimum items to be selected in this step",
		},
		max: {
			label: "Max selectable qty for the step",
			tooltip: "Maximum items to be selected in this step",
		},
	},
	fiscalSplit: {
		enabled: "Fiscal split enabled",
		disabled: "Fiscal split disabled",
		title: "FISCAL SPLIT",
		fiscalWeight: {
			label: "% Fiscal weight of step {{stepNumber}}",
			placeholder: "00%",
			info: "The weight (%) determines how much this step represents on the invoice.",
			supplyAlert: {
				title: "There are some supplies in this step",
				message:
					"When the step has both products and supplies, the fiscal weight (%) only defines the participation of products with fiscal data on the invoice. The supplies above do not have fiscal data and will not be issued.",
			},
		},
		summary: {
			title: "Fiscal summary",
			stepPrefix: "Step",
			incomplete: "distribute 100% across the steps",
		},
		dialog: {
			triggerLabel: "Learn more about fiscal split",
			title: "Fiscal split",
			paragraph1:
				"The fiscal split defines how the total invoice amount is distributed across the items of the mountable product.",
			paragraph2: {
				intro:
					"The weights (%) of the steps determine the share of products with fiscal data on the invoice.",
				bold:
					"Supplies do not have fiscal data and will not be issued on the final invoice.",
			},
			example: {
				title: "Example:",
				intro: "A R$ 20 caipirinha:",
				item1: "Base (70%) — cachaça (product with fiscal data): R$ 14",
				item2: "Complements (30%) — sugar (supply) and lime (supply): not issued",
				conclusion:
					"In this case, only the cachaça participates in the invoice value split.",
			},
			close: "Close",
			confirm: "Got it",
		},
	},
	itemsSection: {
		title: "ADDITIONAL ITEMS",
		addItem: "Add another item",
		removeItem: "Remove item",
		clearItem: "Clear item",
		fields: {
			item: {
				label: "Item",
				placeholder: "Select an item",
				loadingPlaceholder: "Loading products...",
			},
			price: {
				label: "Price",
				placeholder: "0.00",
				tooltip:
					"Suggested value based on the product's registered price. Changes made here apply only to this record and don't modify the product's original price.",
				clear: "Clear",
			},
			maxCount: {
				label: "Item max qty",
				placeholder: "0",
				tooltip: "Maximum number of times this item can be selected in the step",
			},
			storageCount: {
				label: "Item deducted qty",
				placeholder: "0",
				tooltip: "Quantity to be deducted from stock per unit",
			},
			isModification: {
				label: "Modification item",
			},
		},
	},
	actions: {
		delete: "Delete mountable product",
		clear: "Clear mountable product",
		deleteConfirmation: {
			title: "Delete mountable product",
			description:
				"By confirming this action you permanently delete the mountable product. Do you wish to continue?",
			confirm: "Yes, delete it",
			cancel: "Cancel",
		},
		clearConfirmation: {
			title: "Clear mountable product",
			description:
				"By confirming this action you will clear all mountable product data from the form. Do you wish to continue?",
			confirm: "Yes, clear it",
			cancel: "Cancel",
		},
		notifications: {
			deleteSuccess: "Mountable product removed successfully",
			deleteError: "Error removing mountable product",
		},
	},
	preview: {
		toggle: {
			pdv: "POS",
			totem: "Kiosk",
		},
		productNameFallback: "Product name",
		descriptionFallback:
			"Add a description for the product that will be displayed on the POS or Kiosk.",
		seeMore: "See more",
		requiredBadge: "Required",
		stepFallbackTitle: "Step {{n}}",
		itemFallbackName: "Item",
		chooseUpToOne: "Choose up to {{count}} item",
		chooseUpToMany: "Choose up to {{count}} items",
		addCta: "Add {{total}}",
		empty: {
			title: "Preview",
			description: "Steps will appear here as you fill out the form.",
		},
		illustrativeNotice:
			"This is an illustrative preview and may differ from the actual POS or Kiosk display.",
		previewActionTooltip: "Preview only — actions aren't available here.",
		expandPreview: "Expand preview",
	},
};
